module.exports = __webpack_public_path__ + "static/media/FL_logo_anniversary.1caf551a.png";